import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import FormSection from '../../../../components/FormComponents/FormSection';
import TextInputFieldWithValidation from '../../../../components/ValidationFormElements/TextInputFieldWithValidation';
import AccidentDiscovererIcon from '../../../../img/formSectionIcons/accidentDiscoverer.svg';
import Validation from '../../../../components/Validation/Validation';
import MainRadio from '../../../../components/MUI/MainRadio';
import { ACCIDENT_DISCOVERER_IS } from '../../options';

const AccidentDiscoverer = ({
  formProps: { errors, clearError, register },
  accidentDiscovererIs,
  handleAccidentDiscovererIsChange,
  handleChange,
}) => (
  <FormSection title="propertyClaim.accInfo.accidentDiscovererIs" icon={AccidentDiscovererIcon}>
    <Validation name="accidentDiscovererIs" errors={errors}>
      <Grid container spacing={4} style={{ marginBottom: 10 }}>
        {Object.values(ACCIDENT_DISCOVERER_IS).map(({ value, label }) => (
          <Grid
            item
            xs={12}
            key={label}
          >
            <MainRadio
              name="accidentDiscovererIs"
              labelKey={label}
              value={value}
              checked={value === accidentDiscovererIs}
              onChange={() => handleAccidentDiscovererIsChange(value)}
            />
          </Grid>
        ))}
      </Grid>
    </Validation>
    {accidentDiscovererIs === ACCIDENT_DISCOVERER_IS.other.value && (
    <Grid item xs={12} style={{ marginBottom: 10 }}>
      <TextInputFieldWithValidation
        labelKey="propertyClaim.accInfo.accidentDiscovererOther"
        name="accidentDiscovererOther"
        register={register}
        multiline
        rows={4}
        onChange={handleChange}
        formProps={
              {
                errors,
                clearError,
              }
            }
      />
    </Grid>
    )}
  </FormSection>
);

AccidentDiscoverer.propTypes = {
  formProps: PropTypes.shape({
    errors: PropTypes.shape({}),
    register: PropTypes.func,
    clearError: PropTypes.func,
  }).isRequired,
  accidentDiscovererIs: PropTypes.string,
  handleChange: PropTypes.func,
  handleAccidentDiscovererIsChange: PropTypes.func,
  i18n: PropTypes.shape({
    t: PropTypes.func,
  }).isRequired,
};

AccidentDiscoverer.defaultProps = {
  accidentDiscovererIs: '',
  handleAccidentDiscovererIsChange: () => {},
  handleChange: () => {},
};

export default AccidentDiscoverer;
